import { HEX_000000, HEX_121820, HEX_E2E8F0, HEX_FFFFFF } from '@tanium/colors';
import { defineColor } from '@tanium/react-theme-definition';

export const PlaceholderFill = defineColor([HEX_E2E8F0, HEX_121820]);
export const FadeFill = defineColor([HEX_FFFFFF, HEX_000000]);
